var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuccessIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 800,
  height: 800,
  viewBox: "0 0 512 512",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M256 42.667C138.18 42.667 42.667 138.18 42.667 256S138.18 469.333 256 469.333 469.333 373.82 469.333 256 373.82 42.667 256 42.667m0 384c-94.105 0-170.667-76.562-170.667-170.667S161.895 85.333 256 85.333 426.667 161.895 426.667 256 350.106 426.667 256 426.667m80.336-246.886 30.167 30.167-131.836 132.388-79.084-79.084 30.167-30.166 48.917 48.917z"
})));
export { SvgSuccessIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/successIcon.svg";